export default {
    SESSION: {
        CREATED_AT: 'createdAt',
        CONVERSATION_ID: 'conversationId',
        USER_ID: 'userId',
        CONVERSATION_INITIATED: 'conversationInitiated',
    },
    AGENT_DESK: {
        ZENDESK_KEY: '__zlcmid',
        DEPT_HANDOFF_CODE_SENT: 'deptHandoffCodeSent',
    },
    GREETING: {
        CALLOUT_BUBBLE_GREETING_COOKIE_LABEL: 'calloutBubbleGreetingsTriggered',
        PROACTIVE_GREETING_COOKIE_LABEL: 'proActiveGreetingsTriggered',
    },
    AUTH: {
        USER_LOGGED_IN: 'userLoggedIn',
        AUTH_TOKEN: 'auth_token',
    },
    OAUTH: {
      LOGGED_IN: 'oauth'  
    },
    SPEECH: {
        TOKEN : 'speechToken' 
    }
}
